import React, { useState, useEffect } from "react";
import cn from "classnames";
import styles from "./Panel.module.sass";
import { useNavigate } from "react-router-dom";
import AccessControl from "../../../HOC/AccessControl";
import { openPackingSlip } from "../../../utils/packingSlipUtils"
import Modal from "../../../components/Modal";
import TableIndex from "./OrdersHistoryTable/TableIndex"
const Panel = ({
  cameras,
  handleCapture,
  handleRecording,
  activeRecordings,
  onUpload,
  markAsPacked,
  currentOrder,
}) => {
  const [cameraOptions, setCameraOptions] = useState(() => {
    const savedOptions = localStorage.getItem("cameraOptions");
    if (savedOptions) {
      return JSON.parse(savedOptions);
    } else if (cameras.length === 1) {
      return {
        [cameras[0].deviceId]: { photo: true, video: true },
      };
    } else {
      return {};
    }
  });

  const [isVideoSelected, setIsVideoSelected] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (cameras.length === 1 && Object.keys(cameraOptions).length === 0) {
      setCameraOptions({
        [cameras[0].deviceId]: { photo: true, video: true },
      });
    }

    const hasVideoSelected = Object.values(cameraOptions).some(
      (options) => options?.video
    );
    setIsVideoSelected(hasVideoSelected);
    localStorage.setItem("cameraOptions", JSON.stringify(cameraOptions));
  }, [cameras, cameraOptions]);

  const handleOk = () => {
    if (currentOrder?.id) {
      openPackingSlip(currentOrder.id);
    }
  };
  const handleModalOpen = () => {
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
  };

  return (
    <div className={cn("panel", styles.panel)}>
      <div className={styles.info}>
      <button
          className={cn("button-stroke", styles.button)}
          onClick={handleModalOpen}
        >
          View History
        </button>
      </div>
      <div className={styles.btns}>
        <div className="flex flex-col gap-4">
          <div className="flex flex-wrap gap-4">
            <div>
              <div>   
              <AccessControl
                  moduleCode="diMGeD"
                  requiredPrivilege="mrbNPj" >
                             
                <button
                  className={cn("button-stroke", styles.button)}
                  onClick={handleOk}
                >
                Print Packing Slip
                </button>
                </AccessControl> 
                <button
                  className={cn("button", styles.button)}
                  onClick={markAsPacked}
                >
                  Mark as packed
                </button>
                
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal outerClassName={styles.outer} visible={isModalVisible}  onClose={handleModalClose}>
          <div className={cn(styles.details,"mb-[5%]")}>
            <div className={cn("title-blue", styles.title)}>
                Packing History
            </div>
          </div>
          <div className="p-4 overflow-y-auto max-h-[calc(90vh-8rem)]"><TableIndex/></div>
      </Modal>
    </div>
  );
};

export default Panel;
